<template>
  <v-footer
    app
    elevation="10"
    fixed>
    <slot name="left">
    </slot>
    <v-spacer />
    <slot name="center">
    </slot>
    <v-spacer />
    <slot name="right">
    </slot>
  </v-footer>
</template>

<script>
export default {
  name: 'GlobalFooter',
}
</script>

<style scoped>

</style>
